import { useNavigate, Routes, Route, useLocation, useParams } from 'react-router-dom';
import { Page, Header } from 'daymap-library';
import Logo, { SchoolLogo } from '../../components/Logo/Logo';
import { useApp } from '../../helpers/appContext';
import { useAuth } from '../../helpers/authContext';
import { useEffect } from 'react';
import StudentCodeEntry from '../../components/Containers/StudentCodeEntry';
import RoomSignIn from './RoomSignIn';

function RoomMode()
{
    const navigate = useNavigate();
    const location = useLocation();
    const { signOutMenu } = useAuth();
    const { kioskHeader, setStudent, setKioskHeader } = useApp();
    const { roomId } = useParams();

    useEffect(() => {
        setStudent(null);
        setKioskHeader(null);
      }, [])

    const studentFound = student => {
        setStudent(student);
        navigate(`/room/${roomId}/signin`)
      }

      let pageTitle = <Logo />
      if (kioskHeader)
            pageTitle = kioskHeader;
    
    return (
        <Page hasHeader center>
          <Header title={pageTitle} menus={signOutMenu && [signOutMenu]} />
          <Routes>
            <Route path="/" element={<RoomHome onStudentFound={studentFound} />} />
            <Route path="/signin" element={<RoomSignIn />} />
          </Routes>
        </Page>
      )
}

function RoomHome({onStudentFound}) {
    return <div className={""}>
      <SchoolLogo />
      <StudentCodeEntry onStudentFound={onStudentFound} />
    </div>
  }

  export default RoomMode;